import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges
} from '@angular/core';
import { MessageNotification } from 'src/app/shared/models/message-notification';

@Component({
	selector: 'app-messaging-notification-manager',
	templateUrl: './messaging-notification-manager.component.html',
	styleUrls: ['./messaging-notification-manager.component.scss']
})
export class MessagingNotificationManagerComponent
	implements OnInit, OnChanges
{
	/**
	 * Nombre de message destiné à l'utilisateur
	 */
	notificationNumber = 0;

	@Input() messagingNotifications: MessageNotification[] = [];

	constructor() {}

	ngOnInit(): void {
		this.notificationNumber = this.messagingNotifications
			? this.messagingNotifications.length
			: 0;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.messagingNotifications.isFirstChange()) {
			this.notificationNumber =
				changes.messagingNotifications.currentValue.length;
		}
	}

	resetNotificationNumber() {
		this.notificationNumber = 0;
	}
}
